import { render, staticRenderFns } from "./FollowedStory.vue?vue&type=template&id=ed69b3b4&scoped=true"
import script from "./FollowedStory.vue?vue&type=script&lang=ts"
export * from "./FollowedStory.vue?vue&type=script&lang=ts"
import style0 from "./FollowedStory.vue?vue&type=style&index=0&id=ed69b3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed69b3b4",
  null
  
)

export default component.exports